import { apiGet } from '@/services/api';
import { libraryQuery } from '@/features/publicsite/registry/libraryQuery';
import type { Advisor } from '@/features/publicsite/types/registry/Advisor';
import type { AdvisorCoverage } from '@/features/publicsite/types/registry/AdvisorCoverage';
import type { LibraryPageResponse } from '@/features/publicsite/types/registry/LibraryPageResponse';

const ADVISORS = '/api/v1/public/advisors';

/**
 * Every request /consilieri and /biblioteca make that the library's own api module does not
 * already — the pages and their hooks call these, never a URL.
 */
export const registryApi = {
  /**
   * The whole registry, or the advisers matching a search and a domain of competence — the two
   * narrow together, as the endpoint applies them.
   */
  advisors: (query: string, domain = '') => {
    const params = new URLSearchParams();
    if (query) params.set('q', query);
    if (domain) params.set('domain', domain);
    const qs = params.toString();
    return apiGet<Advisor[]>(qs ? `${ADVISORS}?${qs}` : ADVISORS);
  },
  coverage: () => apiGet<AdvisorCoverage>(`${ADVISORS}/coverage`),
  /** One page of the library for the filters in the URL — see libraryQuery for what is forwarded. */
  libraryPage: (params: URLSearchParams, page: number, size: number) =>
    apiGet<LibraryPageResponse>(libraryQuery(params, page, size)),
  /** A resource's file, counted by the library on the way — a plain link the browser follows. */
  libraryDownloadUrl: (id: string) => `/api/v1/public/library/${id}/download`,
};
